'use client';
import React from 'react';
import '@ant-design/v5-patch-for-react-19';
import {
  StyleProvider,
  createCache,
  extractStyle,
} from '@ant-design/cssinjs/lib';
import { useServerInsertedHTML } from 'next/navigation';

const StyledComponentsRegistry = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const cache = createCache();
  useServerInsertedHTML(() => (
    <style
      id="antd"
      dangerouslySetInnerHTML={{ __html: extractStyle(cache, true) }}
    />
  ));
  return <StyleProvider cache={cache}>{children}</StyleProvider>;
};

export default StyledComponentsRegistry;
